<template>
    <div class="mappopup_mosquito2 boxshadow">
        <!-- <div class="top_area">
            <ul class="mos_sts">
                <li>
                    <p :class="classLevel">{{ mosqLevel.statusNm }}</p>
                </li>
                <li>
                    <p :class="classLevel">{{ mosqActIndi !== '' ? mosqActIndi : '0' }}</p>
                </li>
            </ul>
        </div>
        <div class="bottom_area">
            <jqplotTest />
        </div> -->
        <div style="background-color: white; height: 100%; border-radius: 5px;">
            <Chart :chartid="1639" :params="'param1=' + this.selectedParam" :key="this.selectedParam" 
                    :add-title-style="'showtitle'"/>
        </div>
    </div>
</template>
<script>
import { $_WC , $_TYPE } from '@/confs/common.const';
import { mapGetters } from "vuex";
import jqplotTest from "@/views/realtime/jqplotTest.vue";
import $ from "jquery";
import jqplot from '@/assets/js/jqplot/jquery.jqplot.min.js';
import MeterGaugeRenderer from '@/assets/js/jqplot/jqplot.meterGaugeRenderer.min.js';
import Chart from '@/libs/grip.chart.v3.vue';

export default {


    data: function() {
        return {
            mosqActVal: '',
            jqplot: undefined,
            selectedParam: '논현2동',
        };
    },
    components:{
        jqplotTest,
        Chart,
    },
    watch: {
        mosqActIndi: {
            immediate: true,
            handler: function(newVal, oldVal) {
            }
        },
        selectedMeMosq: {
            immediate: false,
            handler(newVal, oldVal) {
                if(typeof newVal !== 'undefined') {
                    this.selectedParam = newVal.val2;
                    if(typeof newVal.val10 !== $_TYPE.UNDEF){
                        // this.setChart([Number(newVal.val10)]);
                    } else {
                        // this.setChart([Number(this.totalMeMosVal)]);
                    }
                }
            }
        },
        selectedSubMenus: {
            immediate: false,
            handler(newVal, oldVal) {
                if(newVal.includes('mediumMosq')){
                    // this.$store.dispatch('SET_SELECTED_ME_MOSQ', {});
                    // this.setChart([Number(this.totalMeMosVal)]);
                }
            }
        },
    },
    computed: {
        ...mapGetters({
            selectedMeMosq: 'getSelectedMeMosq',
            mosqAct: 'getMosqAct',
            totalMeMosVal: 'getTotalMeMosVal',
            selectedSubMenus: 'getSelectedSubMenus',
        }),
        mosqActIndi: function() {
            let val = '';
            let selectedMeMosq = {};
            // console.log('selectedMeMosq', this.selectedMeMosq);
            if(Object.keys(this.selectedMeMosq).length !== 0) {
                selectedMeMosq = this.selectedMeMosq;
                val = selectedMeMosq.val10;
            } else {
                if(typeof this.mosqAct !== 'undefined') {
                    val = this.mosqAct;
                }
            }
            // console.log('val', val);
            return val;
        },
        classLevel: function() {
            let val = Number(this.mosqActIndi);
            let cls = 'st0';
            if(0 <= val && val < 25) {
                cls += '1';
            } else if(25 <= val && val < 50) {
                cls += '2';
            } else if(50 <= val && val < 75) {
                cls += '3';
            } else {
                cls += '4';
            }
            return cls;
        },
        mosqLevel: function() {
            let val = '';
            let cls = 'st0';
            let map = {};
            let statusNm = '';
            val = Number(this.mosqActIndi);
            if(0 <= val && val < 25) {
                cls += '1';
                statusNm = '1단계(쾌적)';
            } else if(25 <= val && val < 50) {
                cls += '2';
                statusNm = '2단계(관심)';
            } else if(50 <= val && val < 75) {
                cls += '3';
                statusNm = '3단계(주의)';
            } else {
                cls += '4';
                statusNm = '4단계(불쾌)';
            }
            map.cls = cls;
            map.statusNm = statusNm;
            return map;
        },
        imgLevel: function() {
            let clsLevel = this.classLevel;
            clsLevel = clsLevel.substring(3,4);
            return clsLevel;
        },
    },
    created() {
    },
    updated: function() {
    },
    methods: {
        setChart(s1){
            let radius = 60;
            if($_WC.viewScale > 1) {
                radius = 120;
            }
            let plot = $.jqplot('chart4',[s1],{
                seriesDefaults: {
                    renderer: $.jqplot.MeterGaugeRenderer,
                    rendererOptions: {
                        label: "모기활동지수",
                        labelPosition: "bottom",
                        labelHeightAdjust: -5,
                        intervalOuterRadius: radius,
                        ticks: [0,25,50,75,100],
                        intervals: [0,25,50,75,100],
                        intervalColors: ["","#17bb40", "#0d73f0", "#ff731a", "#fd2c42"],
                    },
                    tickOptions: {
                        fontSize: '20px',
                    },
                }
            });
            this.jqplot = plot;
        },
    },
    mounted() {
    },
    mixins: [],
}
</script>

<style>
.mappopup_mosquito2{
    width: 340px;
    height: 270px;
}
@media (min-width: 2737px) and (max-width: 7680px) {
   .mappopup_mosquito2{
        position: absolute;
        left: 117px;
        top: 172px;
        z-index: 99999;
        box-sizing: border-box;
        border-radius: 4px;
        padding: 10px 10px;
        width: 600px;
        border-radius: 3px;
        height: 438px;
   }
   .mappopup_mosquito2 .top_area .mos_sts>li p{
        font-size: 24px;
   }
   .mappopup_mosquito2 .bottom_area{
        margin-top: 68px;
   }

   .jqplot-meterGauge-tick {
       font-size: 20px;
   }
   .jqplot-meterGauge-label {
       font-size: 26px;
   }
}
</style>
